'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useAuth } from '@repo/auth';
import { useMutation } from '@repo/tanstack/query';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger, SidebarMenuButton, SidebarMenuItem, toast, useSidebar } from '@repo/ui/components';
import { CircleUserRound, EllipsisVertical, KeyRound, LogOut } from '@repo/ui/icons';
import { useRouter } from 'next/navigation';
import { useRef, useState } from 'react';
import { KitAvatar } from '@repo/features/avatar';
import { ChangePasswordDialog } from './change-password-dialog.tsx';
export function NavUser() {
  const $ = _c(68);
  const {
    isMobile
  } = useSidebar();
  const auth = useAuth();
  const {
    isImpersonating,
    refreshUser,
    user
  } = auth;
  const fileInputRef = useRef(null);
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      fileInputRef.current?.click();
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const triggerFileInput = t0;
  const api = useApi();
  const userId = Number(user?.id) || 0;
  let t1;
  if ($[1] !== api.users.updateAvatar || $[2] !== refreshUser || $[3] !== user || $[4] !== userId) {
    let t2;
    if ($[6] !== refreshUser || $[7] !== user) {
      t2 = async () => {
        if (user) {
          await refreshUser();
        }
        toast.success("Avatar changed successfully");
      };
      $[6] = refreshUser;
      $[7] = user;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = api.users.updateAvatar.mutationOptions({
      path: {
        id: userId
      }
    }, {
      meta: {
        invalidates: [["users"]]
      },
      onError: _temp,
      onSuccess: t2
    });
    $[1] = api.users.updateAvatar;
    $[2] = refreshUser;
    $[3] = user;
    $[4] = userId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    mutate
  } = useMutation(t1);
  let t2;
  if ($[9] !== mutate) {
    t2 = async event => {
      const file = event.target.files?.[0];
      if (!file) {
        return;
      }
      mutate({
        avatar: file
      });
    };
    $[9] = mutate;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const handleAvatarChange = t2;
  const router = useRouter();
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "none"
    };
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== handleAvatarChange) {
    t4 = <input accept="image/*" onChange={handleAvatarChange} ref={fileInputRef} style={t3} type="file" />;
    $[12] = handleAvatarChange;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SidebarMenuButton className="data-popup-open:bg-sidebar-accent data-popup-open:text-sidebar-accent-foreground" size="lg" />;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== user) {
    t6 = <KitAvatar className="size-8" user={user} variant="square" data-sentry-element="KitAvatar" data-sentry-source-file="nav-user.tsx" />;
    $[15] = user;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = user?.name;
  let t8;
  if ($[17] !== t7) {
    t8 = <span className="truncate font-medium">{t7}</span>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = user?.email;
  let t10;
  if ($[19] !== t9) {
    t10 = <span className="truncate text-xs text-muted-foreground">{t9}</span>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8) {
    t11 = <div className="grid flex-1 text-left text-sm leading-tight">{t8}{t10}</div>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <EllipsisVertical className="ml-auto size-4" data-sentry-element="EllipsisVertical" data-sentry-source-file="nav-user.tsx" />;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t6) {
    t13 = <DropdownMenuTrigger render={t5} data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="nav-user.tsx">{t6}{t11}{t12}</DropdownMenuTrigger>;
    $[25] = t11;
    $[26] = t6;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = isMobile ? "bottom" : "right";
  let t15;
  if ($[28] !== user) {
    t15 = <KitAvatar className="size-8" user={user} variant="square" data-sentry-element="KitAvatar" data-sentry-source-file="nav-user.tsx" />;
    $[28] = user;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  const t16 = user?.name;
  let t17;
  if ($[30] !== t16) {
    t17 = <span className="truncate font-medium">{t16}</span>;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = user?.email;
  let t19;
  if ($[32] !== t18) {
    t19 = <span className="truncate text-xs text-muted-foreground">{t18}</span>;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t17 || $[35] !== t19) {
    t20 = <div className="grid flex-1 text-left text-sm leading-tight">{t17}{t19}</div>;
    $[34] = t17;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t15 || $[38] !== t20) {
    t21 = <DropdownMenuGroup data-sentry-element="DropdownMenuGroup" data-sentry-source-file="nav-user.tsx"><DropdownMenuLabel className="p-0 font-normal" data-sentry-element="DropdownMenuLabel" data-sentry-source-file="nav-user.tsx"><div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">{t15}{t20}</div></DropdownMenuLabel></DropdownMenuGroup>;
    $[37] = t15;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <DropdownMenuSeparator data-sentry-element="DropdownMenuSeparator" data-sentry-source-file="nav-user.tsx" />;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <DropdownMenuItem onClick={triggerFileInput} data-sentry-element="DropdownMenuItem" data-sentry-source-file="nav-user.tsx"><CircleUserRound data-sentry-element="CircleUserRound" data-sentry-source-file="nav-user.tsx" />Change avatar</DropdownMenuItem>;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== isImpersonating) {
    t24 = !isImpersonating && <DropdownMenuItem onClick={() => setIsChangingPassword(true)}><KeyRound />Change password</DropdownMenuItem>;
    $[42] = isImpersonating;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t24) {
    t25 = <DropdownMenuGroup data-sentry-element="DropdownMenuGroup" data-sentry-source-file="nav-user.tsx">{t23}{t24}</DropdownMenuGroup>;
    $[44] = t24;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <DropdownMenuSeparator data-sentry-element="DropdownMenuSeparator" data-sentry-source-file="nav-user.tsx" />;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== auth || $[48] !== router) {
    t27 = async () => {
      await auth.logout();
      router.replace("/");
      router.refresh();
    };
    $[47] = auth;
    $[48] = router;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <LogOut data-sentry-element="LogOut" data-sentry-source-file="nav-user.tsx" />;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== t27) {
    t29 = <DropdownMenuGroup data-sentry-element="DropdownMenuGroup" data-sentry-source-file="nav-user.tsx"><DropdownMenuItem onClick={t27} data-sentry-element="DropdownMenuItem" data-sentry-source-file="nav-user.tsx">{t28}Log out</DropdownMenuItem></DropdownMenuGroup>;
    $[51] = t27;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== t14 || $[54] !== t21 || $[55] !== t25 || $[56] !== t29) {
    t30 = <DropdownMenuContent align="end" className="w-(--anchor-width) min-w-56 rounded-lg" side={t14} sideOffset={4} data-sentry-element="DropdownMenuContent" data-sentry-source-file="nav-user.tsx">{t21}{t22}{t25}{t26}{t29}</DropdownMenuContent>;
    $[53] = t14;
    $[54] = t21;
    $[55] = t25;
    $[56] = t29;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] !== t13 || $[59] !== t30) {
    t31 = <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-source-file="nav-user.tsx">{t13}{t30}</DropdownMenu>;
    $[58] = t13;
    $[59] = t30;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== isChangingPassword || $[62] !== userId) {
    t32 = <ChangePasswordDialog onOpenChange={setIsChangingPassword} open={isChangingPassword} userId={userId} data-sentry-element="ChangePasswordDialog" data-sentry-source-file="nav-user.tsx" />;
    $[61] = isChangingPassword;
    $[62] = userId;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  let t33;
  if ($[64] !== t31 || $[65] !== t32 || $[66] !== t4) {
    t33 = <SidebarMenuItem data-sentry-element="SidebarMenuItem" data-sentry-component="NavUser" data-sentry-source-file="nav-user.tsx">{t4}{t31}{t32}</SidebarMenuItem>;
    $[64] = t31;
    $[65] = t32;
    $[66] = t4;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  return t33;
}
function _temp(error) {
  console.error("error", error);
  toast.error("File size too large. Max 2mb");
}